import { FileWarning } from "lucide-react";

// Build D · oct-2026 · Avisos de datos fiscales (no bloquean). Calculados en vivo por el backend.
const rolTxt = (r) => (r === "titular" ? "Titular" : "Obligado solidario");

export const EtiquetaSinDatosFiscales = ({ testid }) => (
  <span data-testid={testid}
    className="inline-flex w-fit items-center rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-[10px] font-semibold text-amber-800">
    Sin datos fiscales
  </span>
);

export function AvisosDatosFiscales({ avisos, testid, titulo = "Sin datos fiscales" }) {
  if (!avisos?.length) return null;
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50/70 p-3" data-testid={testid}>
      <div className="mb-1.5 flex flex-wrap items-center gap-2 text-amber-900">
        <FileWarning className="h-4 w-4" />
        <p className="font-heading text-sm font-semibold">{titulo}</p>
        <span className="text-[11px] text-amber-700">Aviso · no bloquea</span>
      </div>
      <div className="space-y-1.5">
        {avisos.map((p) => (
          <div key={p.cliente_id} data-testid={`${testid}-${p.cliente_id}`} className="text-[13px] text-amber-900">
            <p className="font-medium">
              {p.cliente}
              <span className="ml-1.5 rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-medium text-amber-800">{rolTxt(p.rol)}</span>
            </p>
            <ul className="mt-0.5 list-inside list-disc space-y-0.5">
              {p.avisos.map((a, i) => <li key={i} data-testid={`${testid}-${p.cliente_id}-aviso-${i}`}>{a}</li>)}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export function AvisosFiscalesCreditos({ creditos }) {
  const con = (creditos || []).filter((c) => c.sin_datos_fiscales);
  if (!con.length) return null;
  return (
    <div className="space-y-2" data-testid="c360-avisos-fiscales">
      {con.map((c) => (
        <AvisosDatosFiscales key={c.id} avisos={c.avisos_fiscales} testid={`c360-avisos-fiscales-${c.id}`}
          titulo={<><span className="font-mono">{c.numero_credito}</span> · Sin datos fiscales</>} />
      ))}
    </div>
  );
}
